export default {
  // auth: [
  //   {
  //     path: '/race-login',
  //     name: 'racewaybooking.login',
  //     component: require('../components/raceway-booking-form/parts/pages/login'),
  //   },
  // ],
  routes: [
    // {
    //   path: '/race-login',
    //   name: 'racewaybooking.login',
    //   component: require('../pages/login'),
    //   guards: ['guest']
    // },
    // {
    //   path: '/race-registration',
    //   name: 'racewaybooking.register',
    //   component: require('../pages/registration'),
    //   guards: ['guest']
    // },
    // {
    //   path: '/',
    //   name: 'racewaybooking.init',
    //   component: require('../pages/raceway-booking-form'),
    //   guards: ['guest'],
    //   meta: {
    //     noAssign: true
    //   }
    // },
    // {
    //   path: '/race-cart',
    //   name: 'racewaybooking.cart',
    //   component: require('../pages/cart'),
    //   guards: ['guest']
    // },
    // {
    //   path: '/race-billing-details',
    //   name: 'racewaybooking.billing',
    //   component: require('../pages/billing'),
    //   guards: ['guest']
    // },
    // {
    //   path: '/race-booking-success',
    //   name: 'racewaybooking.final',
    //   component: require('../pages/final'),
    //   guards: ['guest']
    // },

  ],
}
